<template>
    <div class="uk-container uk-container-small">
        <div class="uk-card uk-card-default uk-card-body uk-width-1-1@m mt-5">
            <div class=" uk-width-1-1@m">
                <h2 class="uk-modal-title">Créer un retour de livraison</h2> <br>
                <form @submit.prevent="updateColis">
                    <div class="uk-margin">
                    <autocomplete :search="search"
                        placeholder="Choisir un livreur"
                        aria-label="Choisir un livreur"
                        :get-result-value="getResultValue"
                        @submit="selectLivreur"
                        ></autocomplete>
                    </div>
                </form>
                <form @submit.prevent="createRetour">
                    <fieldset class="uk-fieldset">
                        <div class="uk-margin">
                            <label for="nature_coli"> <b>Nom du livreur</b> </label>
                            <input class="uk-input" name="nom_livreur" id="nom_livreur" type="text" v-model="retour.nom_livreur" placeholder="Nom du livreur" required>
                        </div>
                        <div class="uk-margin">
                            <label for="nom_boutique"> <b>Nom de la boutique :</b> </label>
                            <input class="uk-input" name="nom_boutique" id="nom_boutique" type="text" v-model="retour.nom_boutique" placeholder="Nom de la boutique" required>
                        </div>
                        <div class="uk-margin">
                            <label for="lieu_livraison"> <b>Lieu de livraison :</b> </label>
                            <input class="uk-input" name="lieu_livraison" id="lieu_livraison" type="text" v-model="retour.lieu_livraison" placeholder="Lieu de la livraison" required>
                        </div>
                        <div class="uk-margin">
                            <label for="num_dest"> <b>Numéro du destinataire :</b> </label>
                            <input class="uk-input" name="num_dest" id="num_dest" type="text" v-model="retour.phone_destinataire" placeholder="N° Tel Destinataire" required>
                        </div>
                        <div class="uk-margin">
                            <label for="motif"> <b>Motif du retour :</b> </label>
                            <textarea class="uk-textarea" name="motif" id="motif" v-model="retour.motif_retour" rows="5" placeholder="Motif du retour"></textarea>
                        </div>
                        <div class="uk-margin uk-flex uk-child-width-auto uk-grid">
                            <label><b>TYPE DE RETOUR :</b></label>
                            <div class="uk-flex">
                                <div class="radios">
                                    <label><input class="uk-radio" type="radio" name="categorie" :value="'Relance'" v-model="retour.relance_retour" checked required>RELANCE</label>
                                </div>
                                <div>
                                    <label><input class="uk-radio" type="radio" name="categorie" :value="'Retour'" v-model="retour.relance_retour" checked required>RETOUR</label>
                                </div>
                            </div>
                        </div>
                        <div class="uk-margin">
                            <label for="date"> <b>Date de relance :</b> </label>
                            <input class="uk-input" name="date" id="date" type="date" v-model="retour.date_relance" placeholder="date de retour" required>
                        </div>
                        <div class="uk-margin">
                            <label class="uk-form-label" for="form-stacked-select"> <b> Satut de relance OU RETOUR :</b> </label>
                            <div class="uk-form-controls">
                                <select class="uk-select" v-model="retour.statut_retour" id="form-stacked-select">
                                    <option :value="'En attente'" selected>EN ATTENTE</option>
                                    <option :value="'Relancé'">RELANCÉ</option>
                                    <option :value="'Retourné'">RETOURNÉ</option>
                                    <option :value="'Livré'">LIVRÉ</option>
                                    <option :value="'Annulé'">ANNULÉ</option>
                                </select>
                            </div>
                        </div>
                    </fieldset>
                    <div class="d-flex justify-content-center">
                        <button class="btn-round my-1 border-0 px-4 uk-button uk-button-primary" type="submit" style=" color:#fff;  font-size:1em !important; ">Valider</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    import { db, dbstore, auth } from '../../main';
    import Swal from "sweetalert2";
    export default {
    data(){
        return{
            retour: {
                nom_livreur: '',
                livreur_id: '',
                nature_coli: "",
                valeur_coli: "",
                nom_boutique: "",
                lieu_livraison: "",
                phone_destinataire: "",
                motif_retour: "",
                id_colis: "",
                relance_retour: "",
                created_at: "",
                date_relance: "",
                statut_retour: "",
            },
            Retours: {},
            Livreur: {},
            livreurs: {},
        }
        
    },
    methods: {
        search(input) {
        if (input.length < 1) { return [] }
            return this.livreurs.filter(unlivreur => {
                return unlivreur.name.toLowerCase()
                    .startsWith(input.toLowerCase())})
            },
        getResultValue(result) {
            return result.name
        },
        selectLivreur(result){
            this.retour.livreur_id = result.id
            this.retour.livreur_name = result.name
        },

        createRetour(event){
        const current = new Date();
        const date = current.getFullYear()+'-'+(current.getMonth()+1)+'-'+current.getDate();
        const time = current.getHours() + ":" + current.getMinutes() + ":" + current.getSeconds();
        const dateTime = date +' '+ time;
        const created_at = dateTime
        const rt = this.retour
        db.ref('Colis Retours').push({
            nom_livreur: "",
            livreur_id: "",
            nature_coli: rt.nature_coli,
            valeur_coli: rt.valeur_coli,
            nom_boutique: rt.nom_boutique,
            lieu_livraison:rt.lieu_livraison,
            phone_destinataire:rt.phone_destinataire,
            motif_retour:rt.motif_retour,
            relance_retour:rt.relance_retour,
            id_colis: rt.id_colis,
            created_at: created_at,
            date_relance: rt.date_relance,
            statut_retour: rt.statut_retour
        })

        this.$router.push({ path: "/admin/livraison/retours"});
        event.target.reset();
        event.preventDefault();
        Swal.fire({
                position: "center",
                icon: "success",
                title: "Crée avec succès",
                showConfirmButton: true,
                timer: 4000,
                allowOutsideClick: false,
            });
        },

        updateColis(){
            if(this.retour.livreur_id) {
                db.ref('Colis Retours').child(this.$route.params.id).child('livreur_id').set(this.retour.livreur_id)
            }
        }
    },

    created() {
    let dbRef = db.ref("Colis Retours").child(this.$route.params.id);
    dbRef
      .get()
      .then((childSnapshot) => {
        const childData = childSnapshot.val();
        this.Retours = childData;
        let dbRef = db
          .ref("users")
          .child(this.Retours.livreur_id)
          .child(this.Retours.livreur_name)
          .get()
          .then((childSnapshot) => {
            const livreurData = childSnapshot.val();
            this.Livreur = livreurData;
          });
      })
      .catch((error) => {
        console.log(error);
      });
    db.ref("users")
      .orderByChild("role")
      .equalTo("1")
      .once("value")
      .then((dataSnapshot) => {
        const itemsArray = [];
        dataSnapshot.forEach((childSnapshot) => {
          const childData = childSnapshot.val();
          itemsArray.push({
            id: childData.id,
            role: childData.role,
            statusLivreur: childData.statusLivreur,
            name: childData.name,
            number: childData.number,
            email: childData.email,
          });
        });
        this.livreurs = itemsArray;
      });
  },
}
</script>
<style>

.uk-textarea {
   background-color: rgba(146, 143, 143, 0.174);
   border-radius: 10px;
}

.radios {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
}

.uk-radio {
  margin-right: 10px;
   margin-left: 10px;
}

</style>